import {datadogRum} from '@datadog/browser-rum';
import {isDevOrStagingEnvironment} from '@/Pages/Common/Utils';

export const initDataDog = () => {
  if (isDevOrStagingEnvironment) {
    return;
  }

  const datadogEnv = import.meta.env.VITE_ENV || 'development';

  datadogRum.init({
    applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID || '',
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN || '',
    site: 'datadoghq.eu',
    service: import.meta.env.VITE_DATADOG_SERVICE_NAME,
    env: datadogEnv,
    version: import.meta.env.VITE_APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask',
    actionNameAttribute: 'data-action-name',
    // https://docs.datadoghq.com/real_user_monitoring/connect_rum_and_traces/?tab=browserrum
    allowedTracingUrls: ['https://cpc.bdts.flix.tech']
  });

  datadogRum.setGlobalContext({
    'fxt.productdomain': 'gbx',
    'fxt.productline': 'bdts',
    'fxt.product': 'cpc'
  });
};
